import React, { forwardRef, useImperativeHandle, useRef, useState } from "react";
import { RCCHTMLTextEditor, RCCRefModalProps } from "react-common-components";
import Modal from "src/components/Modal";
import ModalSide from "src/components/Modal/styles";
import { useTranslation } from "src/context/Translations/context";
import { useForm } from "react-hook-form";
import { ICatba002 } from "../../interface";

export interface IRefIPostItModals{
  actionButtonVisualizeExplanation: (row: ICatba002) => void;
}

const ModalsPostIt: React.ForwardRefRenderFunction<IRefIPostItModals> = (_, ref) => {

	const { translate } = useTranslation();
	const [selectedQuadrant, setSelectedQuadrant] = useState<ICatba002>({} as ICatba002);

	const modalAddOrChange = useRef<RCCRefModalProps>(null);

	const { control } = useForm();

	useImperativeHandle(ref, () => ({
		actionButtonVisualizeExplanation
	}));

	const actionButtonVisualizeExplanation = (row: ICatba002) => {
		setSelectedQuadrant(row);
		modalAddOrChange.current?.openModal();
	};

	return (
		<>
    	<Modal
				ref={modalAddOrChange}
				header={{
					title: translate("Explicação do quadrante"),
					subtitle: `${translate("Quadrante")}: ${translate(selectedQuadrant.caa002Descricao)}`,  
					icon: {
						name: "infoCircle"
					}
				}}
				withoutForm
				footer={{
					showSaveButton: false,
					buttonLoadingText: "",
					saveButtonText: "",
					cancelButtonText:translate("Cancelar")
				}}
				styleInline={ModalSide}
			>
				<RCCHTMLTextEditor
					name="caa002Explicacao"
					label=""
					control={control}
					disabled
					defaultValue={selectedQuadrant.caa002Explicacao || ""}
				/>
			</Modal>
		
		</>
	);
};




export default forwardRef(ModalsPostIt);
